<template>
  <div>
    <el-table :data="currencyTransferList" height="calc(100vh - 300px)">
      <!-- <el-table-column prop="coinName" label="币种名称"> </el-table-column> -->
      <el-table-column prop="coin" label="币种"> </el-table-column>
      <el-table-column prop="tenantName" label="租户名" />
      <el-table-column prop="id" label="id"> </el-table-column>
      <el-table-column prop="fromType" label="出钱包类型"> </el-table-column>
      <el-table-column prop="toType" label="入钱包类型"> </el-table-column>
      <!-- <el-table-column  label="删除开关状态">
        <template slot-scope="scope">
          
          <el-switch
          disabled
            :value="scope.row.isDelete"
            @change="handleChange(scope.row, $event,'isDelete')"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column label="划转开关">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.isTransfer"
            @change="handleChange(scope.row, $event, 'isTransfer')"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            size="small"
            @click="handleEdit(scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="handleRemove(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    >
    </pagination>
    <currency-introduction-detail
      @refresh="refreshList"
      :id="introductionId"
      :val="detailData"
    ></currency-introduction-detail>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Pagination from "components/pagination";
import CurrencyIntroductionDetail from "../detail";
import api from '../../api'
export default {
  name: "CurrencyIntroductionList",
  data() {
    return {
      introductionId: null,
      obj: {},
      detailData: {},
    };
  },
  components: {
    Pagination,
    CurrencyIntroductionDetail,
  },
  computed: {
    ...mapState("currencyTransferSetting", [
      "currencyIntroductionList",
      "currencyTransferList",
      "pagination",
      "totalCount",
    ]),
  },

  methods: {
    ...mapMutations("currencyTransferSetting", ["toggleDetailDialogVisible"]),
    ...mapActions("currencyTransferSetting", ["delOne", "updateOrAdd"]),
    handlePageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleEdit(currency) {
      this.detailData = { ...currency };
      this.introductionId = currency.id;
      this.toggleDetailDialogVisible(true);
    },
    handleChange(row, type, btnType) {
      if (btnType == "isDelete") {
        this.obj = { ...row, isDelete: type };
      }
      if (btnType == "isTransfer") {
        this.obj = { id: row.id, isTransfer: type };
      }
      const message = type
        ? `确认要开启划转开关？`
        : `确认要关闭划转开关？关闭该功能，相关的交易对交易功能也将关闭。`;

      this.$confirm(message, "提示", { type: "warning" }).then(() => {
        api.updateOrUpdateStatus(this.obj).then((res) => {
          if (res.code == 0) {
            this.$emit("refresh");
          }
        });
      });
    },
    handleRemove(id) {
      this.$confirm("确认要删除该划转币种吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.delOne(id).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除成功！");
            this.$emit("refresh", { page: 1, size: 25, status: "" });
          }
        });
      });
    },
    refreshList() {
      this.$emit("refresh");
    },
  },
};
</script>

<style lang="less" scoped></style>
